export enum QuickAddRowPosition {
    FIRST = "first",
    LAST = "last"
}
